import dataEN from './locales/en.json' assert { type: 'json' };
import dataFR from './locales/fr.json' assert { type: 'json' };

export async function loadTranslations(lang = 'fr') {
  return lang === 'en' ? dataEN : dataFR;
}

export const breakpoints = {
  xs: 480,
  sm: 768,
  md: 1024,
  lg: 1280,
  xl: 1440,
  '2xl': 1920,
  '3xl': 2560
};


export function loadYouTubeAPI() {
    const url = 'https://www.youtube.com/player_api';

    if (!document.querySelector(`script[src="${url}"]`)) {
        let tag = document.createElement('script');
        tag.src = url;

        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        console.log("API YouTube chargée !");
    } else {
        console.log("API YouTube déjà chargée, pas de double insertion.");
    }
}
